import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const deleteApp = async ({ tenantId, identifier }, { client }) => {
    return await client.pim.request(graphql(`
      mutation DeleteApp($tenantId: ID!, $identifier: String!) {
        app {
          delete(identifier: $identifier, tenantId: $tenantId)
        }
      }
    `), { tenantId, identifier });
};
